module.exports = __webpack_public_path__ + "img/icon_trade_usage_hover.9d204d3.svg";